import { render, staticRenderFns } from "./SupportersUseList.vue?vue&type=template&id=72f7e7f6&"
import script from "./SupportersUseList.vue?vue&type=script&lang=js&"
export * from "./SupportersUseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports